import { SearchModel } from "./search";
import {prop} from "../../decorators/property";

export class JurisdictionOverrideModel extends Backbone.Model {

    @prop() public Name: string;
    @prop() public Id: number;
    @prop() public Ticked = false;
    public searchModel: SearchModel;

    constructor(searchModel, options?: any) {
        super(options);
        this.searchModel = searchModel;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/jurisdiction-override-model.ts